var fn = function fn(JsonRPCService) {
    return {
        requestCallback: function requestCallback(JobNumber, PhoneNumber) {

            return JsonRPCService.send('quote', 'quote', 'requestCallback', [JobNumber, PhoneNumber]);
        }
    };
};

fn.$inject = ['JsonRPCService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/services/CPPRequestCallbackService.js
// module id = 831
// module chunks = 0